import * as Authorization from './Authorization';
import * as Cart from './Cart';
import * as CartSearch from './CartSearch';
import * as Checkout from './Checkout';
import * as PartnerCheckout from './PartnerCheckout';
import * as OrderSearch from './OrderSearch';

// The top-level state object
export interface ApplicationState {    
    authorization: Authorization.IState | undefined;
    cart: Cart.IState | undefined;
    cartSearch: CartSearch.IState | undefined;
    checkout: Checkout.IState | undefined;
    partnerCheckout: PartnerCheckout.IState | undefined;
    orderSearch: OrderSearch.IState | undefined;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {    
    authorization: Authorization.reducer,
    cart: Cart.reducer,
    cartSearch: CartSearch.reducer,
    checkout: Checkout.reducer,
    partnerCheckout: PartnerCheckout.reducer,
    orderSearch: OrderSearch.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
